var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.43 597.79L45.43 42.2L441.32 42.2L441.32 179.92L483.53 137.72C483.53 67.75 483.53 28.88 483.53 21.1C483.53 9.45 474.08 0 462.43 0C418.62 0 68.13 0 24.32 0C12.67 0 3.22 9.45 3.22 21.1C3.22 80.88 3.22 559.12 3.22 618.9C3.22 630.55 12.67 640 24.32 640C68.13 640 418.62 640 462.43 640C474.08 640 483.53 630.55 483.53 618.9C483.53 603.42 483.53 526.01 483.53 386.68L441.32 428.89L441.32 597.79L45.43 597.79Z",
    id: "a1PGpEVgZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64 92.82C98.74 92.82 91.52 100.05 91.52 108.95C91.52 117.85 98.74 125.07 107.64 125.07C134.79 125.07 351.96 125.07 379.1 125.07C388.01 125.07 395.23 117.85 395.23 108.95C395.23 100.05 388.01 92.82 379.11 92.82C324.81 92.82 134.79 92.82 107.64 92.82Z",
    id: "a1es7120q1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.11 178.83C351.96 178.83 134.79 178.83 107.64 178.83C98.74 178.83 91.52 186.05 91.52 194.96C91.52 203.86 98.74 211.08 107.64 211.08C134.79 211.08 351.96 211.08 379.1 211.08C388.01 211.08 395.23 203.86 395.23 194.96C395.23 186.05 388.01 178.83 379.11 178.83Z",
    id: "go4Rt6jtv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64 264.84C98.74 264.84 91.52 272.06 91.52 280.97C91.52 289.87 98.74 297.09 107.64 297.09C122.08 297.09 194.25 297.09 324.16 297.09L356.42 264.84C207.15 264.84 124.23 264.84 107.64 264.84Z",
    id: "bf8k7zk8S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.31 350.85C258.54 350.85 124.41 350.85 107.64 350.85C98.74 350.85 91.52 358.07 91.52 366.97C91.52 375.87 98.74 383.1 107.64 383.1C117.99 383.1 169.72 383.1 262.83 383.1L266.21 371.75C269.74 362.21 272.78 355.24 275.31 350.85Z",
    id: "do7QIEyzk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.52 452.98C91.52 461.88 98.74 469.11 107.64 469.11C121.81 469.11 235.13 469.11 249.3 469.11C245.12 458.97 244.03 447.76 246.99 436.86C237.7 436.86 191.25 436.86 107.64 436.86C96.89 441.67 91.52 447.05 91.52 452.98Z",
    id: "l4xcqFnOO6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.75 108.95C579.82 108.95 568.36 113.69 559.92 122.14C536.06 146 345.2 336.87 321.34 360.73C314.83 367.23 310.05 375.25 307.42 384.06C305.52 390.44 290.31 441.42 288.4 447.79C287.6 450.49 288.33 453.41 290.33 455.41C291.78 456.87 293.74 457.65 295.74 457.65C296.47 457.65 297.21 457.55 297.94 457.33C304.31 455.43 355.29 440.22 361.66 438.31C370.49 435.68 378.5 430.9 385 424.39C408.86 400.54 599.74 209.67 623.59 185.81C632.04 177.37 636.78 165.92 636.78 153.98C636.78 142.04 632.04 130.59 623.6 122.15C615.15 113.69 603.69 108.95 591.75 108.95Z",
    id: "aenRcOAhq"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1PGpEVgZ",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1PGpEVgZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1es7120q1",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1es7120q1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#go4Rt6jtv",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#go4Rt6jtv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bf8k7zk8S",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bf8k7zk8S",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#do7QIEyzk",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#do7QIEyzk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l4xcqFnOO6",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l4xcqFnOO6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aenRcOAhq",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aenRcOAhq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartFormIcon);
export default __webpack_public_path__ + "static/media/smart-form-icon.bb6322e08d6bf1c40acceb825492a065.svg";
export { ForwardRef as ReactComponent };